import { bokehTheme } from '@vimeo/bokeh-theme';

import { useMediaQueryVisibility } from './useMediaQueryVisibility';

/**
 * Returns true if the window size is at a breakpoint we consider "mobile".
 * Optionally also checks the device orientation and only returns true if we're
 * in portrait.
 */
export const useIsMobile = (portraitOnly = false): boolean => {
  let mediaQuery = `screen and (max-width: ${bokehTheme.breakpoints.md})`;
  mediaQuery += portraitOnly ? ' and (orientation: portrait)' : '';

  return useMediaQueryVisibility(mediaQuery);
};
